import { render, staticRenderFns } from "./JoszakiEmptyMessage.vue?vue&type=template&id=2ec9896c"
import script from "./JoszakiEmptyMessage.vue?vue&type=script&lang=js"
export * from "./JoszakiEmptyMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports